import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { IParametrosGlobais } from 'src/integracoes/servicos/mongo-atlas/modelos/IParametrosGlobais';
import { getParametrosGlobaisSuccess, parametrosGlobaisErrorMsg, updateParametrosGlobaisSuccess } from './actions';
import { GET_PARAMETROS_GLOBAIS_INIT, UPDATE_PARAMETROS_GLOBAIS_INIT } from '../actionTypes';
import { atualizarParametrosGlobais, listarParametrosGlobais } from 'src/integracoes/servicos/mongo-atlas/funcoes/parametrosGlobais';

// -------------------Obter Paramêtros Globais-----------------------------
const fetchObtemParametrosGlobais = async () => {
  try {
    const { status, dados, mensagem } = await listarParametrosGlobais();

    if (status) {
      return {
        isError: false,
        parametrosGlobais: dados,
        errorMessage: ''
      };
    }
    return {
      isError: true,
      parametrosGlobais: null,
      errorMessage: mensagem
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* paraseObtemParametrosGlobais() {
  try {
    const { isError, parametrosGlobais, errorMessage } = yield call(fetchObtemParametrosGlobais);
    if (!isError) {
      yield put(getParametrosGlobaisSuccess({ parametrosGlobais }));
    } else {
      yield put(parametrosGlobaisErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(parametrosGlobaisErrorMsg({ msg: mensagem }));
  }
}

export function* watchObtemParametrosGlobais() {
  yield takeEvery(GET_PARAMETROS_GLOBAIS_INIT, paraseObtemParametrosGlobais);
}

// --------------------------- Atualiza Paramêtros Globais ---------------------------------------------------------
const fetchAtualizaParametrosGlobais = async (id: string, parametros: IParametrosGlobais) => {
  try {
    const { status, dados, mensagem } = await atualizarParametrosGlobais(id, parametros);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizaParametrosGlobais({ payload }: { payload: any, type: any }) {
  const { id, parametros } = payload;
  
  try {
    const { isUpdated, msg } = yield call(fetchAtualizaParametrosGlobais, id, parametros);
    if (isUpdated) {
      yield put(updateParametrosGlobaisSuccess({ msg }));
    } else {
      yield put(parametrosGlobaisErrorMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(parametrosGlobaisErrorMsg({ msg: mensagem }));
  }
}

export function* watchAtualizaParametrosGlobais() {
  yield takeEvery(UPDATE_PARAMETROS_GLOBAIS_INIT, parseAtualizaParametrosGlobais);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchObtemParametrosGlobais),
    fork(watchAtualizaParametrosGlobais)
  ]);
}
